import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { FileIcon, SmsIcon } from '@/icons';
import { LogsManagementIcon } from '@/icons/logs-management-icon';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/logs-management')({
  loader: ({ context }) => {
    context.groupLabel = 'logsManagement.sidebar.group.title';
    context.childRoutes = [
      {
        id: 'logsManagement.sidebar.menu.smsLogs',
        label: 'SMS Logs',
        path: '/logs-management/sms-logs',
        icon: SmsIcon,
      },
      {
        id: 'logsManagement.sidebar.menu.emailLogs',
        label: 'Email Logs',
        icon: LogsManagementIcon,
        path: '/logs-management/email-logs',
      },
      {
        id: 'logsManagement.sidebar.menu.accessLogs',
        label: 'Access Logs',
        path: '/logs-management/access-logs',
      },
      {
        id: 'logsManagement.sidebar.menu.apiLogs',
        label: 'Api Logs',
        path: '/logs-management/api-logs',
      },
      {
        id: 'logsManagement.sidebar.menu.staticDataType',
        label: 'Static Data Type',
        icon: FileIcon,
        path: '/logs-management/static-data-type',
      },
    ];
    return {
      crumb: <CrumbTitle id="logsManagement.page.crumb" icon={LogsManagementIcon} />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
